import * as React from 'react';
import Text from '../Base/Text/Text';
import { useAppContext } from '../../Services/AppContext';
import usePrice from '../../Modules/utils/Hooks/usePrice';

interface PriceProps {
	price: number;
	customSuffix?: string;
}

const Price: React.FC<PriceProps> = props => {
	const { customSuffix } = props;
	let { price } = props;
	const { currency, translation } = useAppContext();
	const currencyCodeKey = 'base.currencyCode.' + currency;
	const currencySuffix = translation[currencyCodeKey];
	const { formattedPriceString } = usePrice();

	if (isNaN(price)) {
		price = 0;
	}

	if (['czk'].includes(currencySuffix.toLowerCase())) {
		return (
			<Text>
				{formattedPriceString(price)}{' '}
				{customSuffix ? customSuffix : currencySuffix}
			</Text>
		);
	}

	return (
		<Text>
			{customSuffix ? customSuffix : currencySuffix}{' '}
			{formattedPriceString(price)}
		</Text>
	);
};

export default Price;
